export const formatNumberToReais = (value: number): string => {
  const reais = value.toFixed(2).replace('.', ',');
  return `R$ ${reais}`;
}

export const formatStringToReais = (value: string): string => {
  return `R$ ${value}`;
}

export const formatStringToReaisNumberFormat = (value: string) => {
  let [integerPart, decimalPart] = value.split('.');
  integerPart = parseInt(integerPart).toLocaleString('pt-BR');
  if (!decimalPart) {
    decimalPart = "00";
  }
  return `${integerPart},${decimalPart}`;
}